import script from "./application-for-residency.vue?vue&type=script&lang=ts&setup=true"
export * from "./application-for-residency.vue?vue&type=script&lang=ts&setup=true"

import "./application-for-residency.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__